import React from "react";
import SVGLogo from "./kraftheinz-logo.svg";
import LogoComponent from "./KraftHeinzLogo";
import clientOnlyResources from ".";
import theme from "./theme";
import TeamIcon from "@mui/icons-material/Business";
// import ContactsIcon from "@mui/icons-material/Contacts";
// import FolderSharedIcon from "@mui/icons-material/FolderShared";
// import FolderSpecialIcons from "@mui/icons-material/FolderSpecial";
import ProductCategoryIcon from "@mui/icons-material/Dns";
import BusinessCenter from '@mui/icons-material/BusinessCenter';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
// import Alarm from '@mui/icons-material/Alarm';
// import DavFiles from "dav_files";
import retry from "custom_components/retry";
import {
  fullFeatureList,
  storeAttrOptions,
  storeGroupByOptions,
  itemAttrOptions,
  storeFilterOptions,
  itemGroupColumnOptions,
  runtimeItemGroupFilterOptions,
} from "./hardcoded_features";

const appConfig = {
  CLIENT_NAME_LABEL: "Kraft-Heinz",
  CLIENT_NAME: "kraftheinz",
  CLIENT_LOGO: SVGLogo,
  APP_BAR_LOGO: LogoComponent,
  AUTH_SUPPLIER_SOURCES: [{ id: "DST", name: "DST" }, { id: "MS2", name: "MS2" }],
  USER_ROLES: [
    { id: "kraftheinz", name: "KraftHeinz" },
    {
      id: "kraftheinz_admin",
      name: "KraftHeinz Admin",
    },
    { id: "site_admin", name: "Site Admin" },
  ],
  CLIENT_CUSTOM_ROUTES: [
    // {
    //   path: "/files/kraftheinz_admin",
    //   component: DavFiles,
    //   allowedRoles: ["kraftheinz_admin", "site_admin"],
    // },
    // {
    //   path: "/files/kraftheinz",
    //   component: DavFiles,
    //   allowedRoles: ["kraftheinz", "kraftheinz_admin", "site_admin"],
    // },
  ],
  EXTRA_MENUS: {
    menuCustomer: [
      {
        to: `/kraftheinz_sales_territory`,
        label: "Sales Territory",
        icon: <BusinessCenter />,
        featureTag: "sales_territory",
      },
      {
        to: `/kraftheinz_chain_status`,
        label: "Chain Status",
        icon: <TeamIcon />,
        featureTag: "chain_status",
      },
      {
        to: `/kraftheinz_chain_rep`,
        label: "Chain Rep",
        icon: <AssignmentIndIcon />,
        featureTag: "chain_rep",
      }
      // {
      //   to: `/kraftheinz_broker`,
      //   label: "Broker",
      //   icon: <ContactsIcon />,
      //   featureTag: "broker",
      // },
    ],
    menuItem: [
      {
        to: `/kraftheinz_business_unit`,
        label: "Business Unit",
        icon: <ProductCategoryIcon />,
        featureTag: "business_unit",
      },
    ],
    // menuFiles: [
    //   // {
    //   //   // side menu link for Kraftheinz Admin File access
    //   //   to: "/files/kraftheinz_admin",
    //   //   label: "Admin Files",
    //   //   icon: <FolderSpecialIcons />,
    //   //   allowedRoles: ["kraftheinz_admin", "site_admin"],
    //   // },
    //   // {
    //   //   // side menu link for Kraftheinz File Access
    //   //   to: `/files/kraftheinz`,
    //   //   label: "Files",
    //   //   icon: <FolderSharedIcon />,
    //   //   allowedRoles: ["kraftheinz", "kraftheinz_admin", "site_admin"],
    //   // },
    // ],
    // 'extraMenu': {}
  },
  CUSTOM_PAGES: {
    master_chain: {
      list: null,
      edit: null,
      // edit: React.lazy(() =>
      //   retry(() => import("./master_chain/MasterChainEdit"))
      // ),
      // list: null,
    },
    master_distributor: {
      list: null,
      edit: null,
      // edit: React.lazy(() =>
      //   retry(() => import("./master_distributor/MasterDistributorEdit"))
      // ),
      // list: null,
    },
    master_customers: {
      // list: null,
      // edit: null
      edit: React.lazy(() => retry(() => import("./master_customers/Edit"))),
      list: React.lazy(() => retry(() => import("./master_customers/List"))),
    },
    master_items: {
      // list: null,
      // edit: null,
      edit: React.lazy(() => retry(() => import("./master_items/Edit"))),
      list: React.lazy(() => retry(() => import("./master_items/List"))),
    }
  },
  DASHBOARD_CONFIG: {
    dimensions: {},
    sunburstHierarchies: {
      "Distributor/Warehouse": ["distributor_name", "warehouse_name"],
      "Product Hierarchy": ["product_hierarchy_level_1"],
    },
  },
  DEPLOY_TARGET_TABS: [
    { id: "main_dashboard", name: "Main Dashboard" }, // default - main dashboard
    { id: "brand_id", name: "Items" }, // default - item level page
    {
      id: "distributor",
      name: "Distributors",
      dimension: "distributor_name",
      targetConfig: {
        resource_name: "kraftheinz_distributor",
        name: "Distributor",
        column_defs: [{ id: 50 }, { name: 350 }],
        filter_column: "warehouse_name@eq",
      },
    }, // default - chain page
    {
      id: "master_chain",
      name: "Chains",
      dimension: "kraftheinz_chain",
      targetConfig: {
        resource_name: "master_chain",
        name: "Chain",
        column_defs: [{ id: 50 }, { primary_name: 350 }],
        filter_column: "kraftheinz_chain@eq",
      },
    }, // default - chain page
  ],
  CUSTOM_RESOURCES: clientOnlyResources,
  CLIENT_THEME: theme,
  BACKGROUND_IMAGE: "bg.jpg",
  featureList: fullFeatureList,
  routeOverrides: {},
  REPORTING_OPTIONS: {
    storeAttrOptions,
    storeGroupByOptions,
    itemAttrOptions,
    storeFilterOptions,
    itemGroupColumnOptions,
    runtimeItemGroupFilterOptions,
    reportAvailability: {
      "Period Comparison": true,
      "Period Comparison Store Level": true,
      "Fact Summary": true,
      "Store Rows/Item Columns Pivot": true,
      "Store Group Rows/Item Columns Pivot": true,
      "Store Rows/Item Columns Pivot (No Item Groups)": true,
      "Item Group Summary": true,
      "ACV by Store Group And Period": true,
    },
    calendarFormat: "544"
  },
};

export default appConfig;
